// @flow
import client from '../../client'

// API Endpoint
export const GET_VEHICLES = '/vehicles/'

/**
 * Get vehicle list from the backend
 * @return {Promise|Error} A resolved Promise with the vehicle data
 */
export const getAllVehicles = (): Promise<any> => client.get(GET_VEHICLES)

export default getAllVehicles
